import { GlucoseSpecialValue } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { useDisplayGlucoseUnit } from "./useDisplayGlucoseUnit"
import { useDisplayGlucoseValue } from "./useDisplayGlucoseValue"
import { usePolyglot } from "src/contexts"

/*
 * returns a function that returns the glucose value and unit
 * in a readable localized string
 */
export function useDisplayGlucoseString(): (value: number, specialValue?: GlucoseSpecialValue) => string {
  const polyglot = usePolyglot()
  const displayGlucoseValue = useDisplayGlucoseValue()
  const displayGlucoseUnit = useDisplayGlucoseUnit()

  return useCallback(
    (
      value: number,
      specialValue: GlucoseSpecialValue = GlucoseSpecialValue.None,
    ) => {
      if (specialValue === GlucoseSpecialValue.None) {
        return polyglot.t(
          "unit.glucose_string",
          {
            value: displayGlucoseValue(value),
            unit: displayGlucoseUnit(),
          },
        )
      }
      return displayGlucoseValue(
        value,
        specialValue,
      )
    },
    [
      polyglot,
      displayGlucoseUnit,
      displayGlucoseValue,
    ],
  )
}
